<mat-stepper linear #stepper>
  <mat-step [stepControl]="setupForm" [formGroup]="setupForm" [editable]="true">
    <ng-template matStepLabel>Content</ng-template>

    <div class="setup-intro">
      <p>
        Use this tile to create a banner with a single linked action. Configure the headline,
        supporting content, image, and destination link in one place.
      </p>
    </div>

    <div class="inputs-container">
      <mat-form-field appearance="fill">
        <mat-label>Heading</mat-label>
        <input matInput formControlName="heading" />
        <mat-hint>Sets the main banner headline.</mat-hint>
        <mat-error *ngIf="headingControl.hasError('required')">Heading is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Sub Heading</mat-label>
        <input matInput formControlName="subHeading" />
        <mat-hint>Adds supporting text below the main headline.</mat-hint>
        <mat-error *ngIf="subHeadingControl.hasError('required')"
          >Sub Heading is required</mat-error
        >
      </mat-form-field>

      <app-data-source-selector
        formControlName="displayFeatureTotal"
        hint="Chooses the datasource used for the featured total shown in the banner."
        (onDataSourceChange)="initDataSource($event)"
      ></app-data-source-selector>

      <mat-form-field appearance="fill">
        <mat-label>Heading Icon</mat-label>
        <input matInput formControlName="headingIcon" />
        <mat-hint>Sets the icon shown alongside the heading.</mat-hint>
        <mat-error *ngIf="headingIconControl.hasError('required')"
          >Heading Icon is required</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Image URI</mat-label>
        <input matInput formControlName="imgUri" />
        <mat-hint>Defines the banner image shown alongside the content.</mat-hint>
        <mat-error *ngIf="imgUriControl.hasError('required')">Image URI is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Link Text</mat-label>
        <input matInput formControlName="linkText" />
        <mat-hint>Sets the label displayed on the banner action.</mat-hint>
        <mat-error *ngIf="linkTextControl.hasError('required')">Link Text is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Route Link</mat-label>
        <input matInput formControlName="routeLink" />
        <mat-hint>Sets the route opened when the banner action is clicked.</mat-hint>
        <mat-error *ngIf="routeLinkControl.hasError('required')">Route Link is required</mat-error>
      </mat-form-field>
    </div>

    <div>
      <button mat-button matStepperNext (click)="setupForm.markAllAsTouched()">Next</button>
    </div>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Confirm</ng-template>
    <p>Title: {{ headingControl.value }}</p>
    <p>Sub Heading: {{ subHeadingControl.value }}</p>
    <p>Data Source: {{ dataSourceObject?.name }}</p>
    <p>Heading Icon: {{ headingIconControl.value }}</p>
    <p>Image URI: {{ imgUriControl.value }}</p>
    <p>Link Text: {{ linkTextControl.value }}</p>
    <p>Route Link: {{ routeLinkControl.value }}</p>
    <div>
      <button mat-button matStepperPrevious>Back</button>
      <button mat-button (click)="onCreate()">Apply</button>
    </div>
  </mat-step>
</mat-stepper>
